import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import PageNavInner from "./PageNavInner";
import getClassNameFactory from "../../utilities/classNames";
import filterWhitespaceNodes from "../../utilities/dom";
var getClassName = getClassNameFactory("PageNavInner");

var rehydrator = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var readData, childrenNode, reactifiedChildren, actionsNode, shareNode, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // eslint-disable-next-line
            readData = function readData(prop) {
              var data = domNode.getAttribute("data-".concat(prop));
              return data ? JSON.parse(data) : null;
            };

            childrenNode = filterWhitespaceNodes(domNode.querySelector(".".concat(getClassName({
              descendantName: "items"
            }))));
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            actionsNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "actions"
            })));
            shareNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "shareInner"
            })));
            props = {
              spy: readData("spy"),
              children: reactifiedChildren,
              linkStyle: domNode.getAttribute("data-link-style")
            };

            if (!actionsNode) {
              _context.next = 12;
              break;
            }

            _context.next = 11;
            return rehydrateChildren(actionsNode);

          case 11:
            props.actions = _context.sent;

          case 12:
            if (!shareNode) {
              _context.next = 16;
              break;
            }

            _context.next = 15;
            return rehydrateChildren(shareNode);

          case 15:
            props.share = _context.sent;

          case 16:
            return _context.abrupt("return", /*#__PURE__*/React.createElement(PageNavInner, props));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function rehydrator(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default rehydrator;